import React from "react";
import Card from "../Card/Card";
import Pricing from "../../organisms/Pricing/Pricing";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";
import { useTranslation } from "react-i18next";

interface SettingsSubscriptionCardProps {
  subscription: string;
}

const SettingsSubscriptionCard = (props: SettingsSubscriptionCardProps) => {
  const { subscription } = props;

  const { t } = useTranslation();

  const user = useSelector((state: RootState) => state.settings.user);
  const hasTrialPeriod =
    user?.trialPeriodEndAt && user?.subscription === "free";

  const getFormattedDate = (dateRaw: Date) => {
    const date = new Date(dateRaw);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  return (
    <Card title={t("subscription")} className="dui-subscription-card">
      {hasTrialPeriod ? (
        <div className="dui-settings-trial">
          {t("trialPeriodEnds")}{" "}
          <span className="dui-settings-tial-date">
            {getFormattedDate(user?.trialPeriodEndAt)}
          </span>
          .
        </div>
      ) : null}
      <Pricing currentPlan={subscription} />
    </Card>
  );
};

export default SettingsSubscriptionCard;
